module.exports = __webpack_public_path__ + "static/media/third_introduction.f8857d46.mp4";